import yyglGetter from '../getters/yyglGetter'
import yyglAction from '../actions/yyglAction'
import yyglMutation from '../mutations/yyglMutation'

const yyglModule = {
  state: {
    approvellist: {},
    enterprise: {},
    enterpriseLearns: {},
    enterpriseTests: {},
    enterpriseEmployees: {},
    enterpriseZjyTestDetails: {},
    enterpriseZjyTestEmployeeRecord: {},
    enterpriseZjyTestEmployees: {},
    enterpriseBdyTestDetails: {},
    enterpriseBdyTestEmployees: {},
    enterpriseBdyTestEmployeeRecord: {},
    enterpriseDetails: {},
    enterpriseRegister: {},
    enterpriseApprove: {},

    learnApprove: {},
    makeUpApprove: {},
    pendingApprovalCount: 0,
    learningmgtYY: {},
    learningmgt: {},
    learningmgtEmployee: {},
    learningmgtEmployeeMockExamRecords: [],
    learningmgtEmployeeLesson: {},
    learningmgtEmployeeLessons: [],
    learningmgtEmployeeLessonLog: [],
    learningmgtEmployeeFaceRecords: [],
    temployeeList: {},
    exportEmployeeExcel: {},
    learnApproveExportBdyExcel: {},
    learnApproveExportBdyZpZip: {},
    learnApproveExportBdyHzbExcel: {},
    learnApproveExportJsgrExcel: {},
    learnEnterprise: {},
    exportEmployeeZp: {},
    exportBdyExcel: {},
    exportJsgrExcel: {},
    yyHasCourse: {},
    learnapproveExportExcel: {},
    learnapproveExportEmployeeExcel: {},
    learnBdyBMExcel: {},
    exportMakeUpApproveExcel: {},
    exportMakeUpjfApproveExcel: {},
    testRooms: {},
    testRoom: {},

    testBatchs: {},
    testBatchDetails: {},
    courseTestBatchs: [],
    testBatchEmployees: {},
    testBatchAddEmployees: {},
    testBatchJobStats: [],
    testBatchEmployeeExcel: {},

    testTrains: {},
    courseTestTrains: [],
    testTrainDetails: {},
    testTrainEmployees: {},
    testTrainEmployeeExcel: {},
    testTrainLessonExcel: {},
    testTrainEmployeeZp: {},

    testSessionStates: [],
    testSessions: {},
    testSessionDetails: {},
    testSessionEmployeeAdmissionTicketUrl: {},
    testSessionEmployees: {},
    testSessionAddEmployees: {},
    testSessionEmployeeExcel: {},
    testSessionTestExcel: {},

    zjpxTrains: {},

    zjyTestBatchs: {},
    zjyTestBatchDetails: {},
    zjyTestBatchEmployees: {},
    zjyTestBatchApproveEmployees: {},
    zjyTestBatchApproveEmployeeCount: 0,

    enterprises: {},

    invoiceApproves: {},
    invoiceApproveCount: {},
    invoiceApproveDpwj: {},
    invoiceApproveDpwjExcel: {},

    newsTestPlan: {},
    newsTestPlanTypes: [],

    newsCategorys: [],
    newsYY: {},

    employees: {},
    employeeDetails: {},
    employeeMnksLearns: [],
    employeeLearns: {},
    employeeTests: {},
    employeePractices: [],

    jsgrTestBatchs: {},
    allJsgrTestBatchs: [],
    jsgrTestBatchJobStats: [],
    jsgrTestBatchEmployees: {},

    jsgrTestTrains: {},
    allJsgrTestTrains: [],
    jsgrTestTrainEmployees: {},
    jsgrTestTrainEmployeeExcel: {},
    jsgrTestTrainLessonExcel: {},

    jsgrTestSessions: {},
    jsgrTestSessionDetails: {},
    jsgrTestSessionEmployees: {},
    addJsgrTestSessionEmployees: {},
    jsgrTestSessionEmployeeExcel: {},

    bdyTestPlanBatchs: {},
    bdyTestPlanBatchJobStats: [],
    bdyTestPlanBatchSessions: {},

    bdyTestBatchs: {},
    bdyTestBatchJobStats: [],
    bdyTestBatchDetails: {},
    bdyTestBatchEmployeeExcel: {},

    bdyTestSessions: {},
    bdyTestSessionJobStats: [],
    bdyTestSessionDetails: {},
    bdyTestSessionEmployees: {},
    bdyTestSessionKcybExcel: {},
    bdyTestSessionEmployeeExcel: {},

    enterpriseModifyApprovesYY: {},
    pendingModifyApprovalCount: {},

    bdyPracticeEnrolls: {},
    bdyPracticeEnrollApprovalCount: {},
    gbdyPracticeEnrollStates: [],
    bdyPracticeEnrollDetails: {},

    questionYYs: [],
    bdyQuestions: {},

    learnInvoices: {},
    learnInvoiceGkDKPCount: 0,
    learnInvoicePxDKPCount: 0,
    learnInvoiceDetails: {},
    learnInvoiceStates: [],
    learnInvoiceDpwj: {},
    learnInvoiceDpExcel: {}
  },
  getters: yyglGetter,
  actions: yyglAction,
  mutations: yyglMutation
};

export default yyglModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/yyglModule.js